module.exports = __webpack_public_path__ + "img/1495918380.f2902e47.jpg";